import { useAppSelector } from "../../../../../redux/hooks";
import { conditions } from "helpers";
import { ConditionName, IVideoTagProps } from "../../../../../interfaces";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";

const StaticVideoTag = dynamic(() => import("./staticVideoTag"));
const NonStaticVideoTag = dynamic(() => import("./nonStaticVideoTag"));
const MultiLiveVideoTag = dynamic(() => import("./multiLiveVideoTag"));

const VideoTag = ({ isMultiLive }: IVideoTagProps) => {
    useAppSelector(({ videoData: { multiLives } }) => ({ multiLives }), shallowEqual);

    return <>{conditions(ConditionName.isStaticFormat) ? <StaticVideoTag /> : isMultiLive ? <MultiLiveVideoTag /> : <NonStaticVideoTag />}</>;
};

export default VideoTag;
